'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _adjust = require('ramda/src/adjust');

var _adjust2 = _interopRequireDefault(_adjust);

var _propEq = require('ramda/src/propEq');

var _propEq2 = _interopRequireDefault(_propEq);

var _findIndex = require('ramda/src/findIndex');

var _findIndex2 = _interopRequireDefault(_findIndex);

var _contains = require('ramda/src/contains');

var _contains2 = _interopRequireDefault(_contains);

var _filter = require('ramda/src/filter');

var _filter2 = _interopRequireDefault(_filter);

var _keys = require('ramda/src/keys');

var _keys2 = _interopRequireDefault(_keys);

var _pickBy = require('ramda/src/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _pipe = require('ramda/src/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Box = require('../Box');

var _Box2 = _interopRequireDefault(_Box);

var _ShapeItem = require('../ShapeItem');

var _ShapeItem2 = _interopRequireDefault(_ShapeItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INIT_STATE = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  scaleXY: {
    scale: 1,
    svgTop: 0,
    svgLeft: 0,
  },
  appearX: 0,
  appearY: 0,
  appearWidth: 0,
  appearHeight: 0,
  mode: 'DRAW',
  menuClick: 0,
};

var SVGContainer = function (_React$PureComponent) {
  _inherits(SVGContainer, _React$PureComponent);

  function SVGContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SVGContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SVGContainer.__proto__ || Object.getPrototypeOf(SVGContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = INIT_STATE, _this.onMouseDown = function (e) {
      if (e.nativeEvent.which !== 1) return;
      var _this$svg$getBounding = _this.svg.getBoundingClientRect(),
          left = _this$svg$getBounding.left,
          top = _this$svg$getBounding.top;

      const x = e.nativeEvent.offsetX || e.pageX - left;
      const y = e.nativeEvent.offsetY || e.pageY - top;
      _this.x = x;
      _this.y = y;
      _this.setState({
        x: x,
        y: y,
        appearX: x,
        appearY: y,
        width: 0,
        height: 0,
        scaleXY: _this.props.scalexy,
      });
      document.addEventListener('mousemove', _this.onMouseMove);
      document.addEventListener('mouseup', _this.onMouseUp);
    }, _this.onMouseMove = function (e) {
      if (!_this.svg) _this.svg = e.path[0];
      var _this$svg$getBounding2 = _this.svg.getBoundingClientRect(),
          left = _this$svg$getBounding2.left,
          top = _this$svg$getBounding2.top;

      const x = e.offsetX || e.pageX - left;
      const y = e.offsetY || e.pageY - top;

      var nextX = Math.min(x, _this.x);
      var nexty = Math.min(y, _this.y);
      const width = Math.abs(x - _this.x);
      const height = Math.abs(y - _this.y);
      _this.setState({
        x: nextX,
        y: nexty,
        appearX: nextX,
        appearY: nexty,
        appearWidth: width,
        appearHeight: height,
        width: width,
        height: height,
      });
    }, _this.onMouseUp = function () {
      _this.x = null;
      _this.y = null;
      document.removeEventListener('mousemove', _this.onMouseMove);
      document.removeEventListener('mouseup', _this.onMouseUp);

      var intersectIds = (0, _pipe2.default)((0, _pickBy2.default)(function (val) {
        return !!val;
      }), _keys2.default)(_this.state.isIntersect);
      var selected = (0, _filter2.default)(function (item) {
        return (0, _contains2.default)(item.id, intersectIds);
      })(_this.props.items);
      _this.props.onSelectChange(selected);

      _this.setState({
        appearX: 0,
        appearY: -5,
        appearWidth: 0,
        appearHeight: 0,
      });
    }, _this.onPositionChange = function (_ref2) {
      var id = _ref2.id,
          others = _objectWithoutProperties(_ref2, ['id']);

      var updateXY = function updateXY(object) {
        return _extends({}, object, others);
      };
      var index = (0, _findIndex2.default)((0, _propEq2.default)('id', id))(_this.props.items);
      var items = (0, _adjust2.default)(updateXY, index)(_this.props.items);
      // for (let i = 0; i <= items.length; i ++) {
      //   if (i === index) return;
      //   if (items[i].tagName === 'text') return;
      //   const intersections = intersect(
      //     shape(items[index].tagName, items[index]),
      //     shape(items[i].tagName, items[i]),
      //   );
      //   if (intersections.points.length > 0) return;
      //
      // }
      _this.props.onItemsChange(items);
    }, _this.onIntersectChange = function (_ref3) {
      var id = _ref3.id,
          isIntersect = _ref3.isIntersect;

      _this.setState(function (state) {
        return {
          isIntersect: _extends({}, state.isIntersect, _defineProperty({}, id, isIntersect))
        };
      });
    }, _this.onRef = function (ref) {
      if (!ref) _this.svg = document.getElementById(".greenArea");
      else _this.svg = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SVGContainer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.isSelectable) this.setState(INIT_STATE);

      const selectBoxGoneState = {
        width: 0,
        height: 0,
        appearX: 0,
        appearY: -5,
        appearWidth: 0,
        appearHeight: 0,
      };
      if (nextProps.mode !== this.state.mode) {
        this.setState({
          mode: nextProps.mode,
          ...selectBoxGoneState,
        });
      }
      if (nextProps.menuClick !== this.state.menuClick) {
        // clicked on context menu function so want select box to disappear
        this.setState({
          menuClick: nextProps.menuClick,
          ...selectBoxGoneState
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onItemsChange = _props.onItemsChange,
          onSelectChange = _props.onSelectChange,
          isSelectable = _props.isSelectable,
          isMovable = _props.isMovable,
          items = _props.items,
          style = _props.style,
          mode = _props.mode,
          otherProps = _objectWithoutProperties(_props, ['onItemsChange', 'onSelectChange', 'isSelectable', 'isMovable', 'items', 'style']);

      var _state = this.state,
          x = _state.x,
          y = _state.y,
          width = _state.width,
          height = _state.height,
          scalexy = _state.scaleXY;

      var onMouseDown = this.onMouseDown,
          onPositionChange = this.onPositionChange,
          onIntersectChange = this.onIntersectChange,
          onRef = this.onRef;

      return _react2.default.createElement(
        'svg',
        Object.assign({
          ref: onRef
        }, otherProps, {
          style: style,
          onMouseDown: isSelectable ? onMouseDown : null
        }),
        items.map(function (_ref4) {
          var tagName = _ref4.tagName,
              id = _ref4.id,
              others = _objectWithoutProperties(_ref4, ['tagName', 'id']);

          return _react2.default.createElement(_ShapeItem2.default, Object.assign({
            id: id,
            key: id,
            tagName: tagName,
            isMovable: isMovable,
            onPositionChange: onPositionChange,
            scalexy: scalexy,
            mode: mode,
          }, others, {
            box: { width: width, height: height, x: x, y: y },
            onIntersectChange: onIntersectChange
          }));
        }),
        _react2.default.createElement(
          _Box2.default,
          { x: _state.appearX, y: _state.appearY, width: _state.appearWidth, height: _state.appearHeight }
        )
      );
    }
  }]);

  return SVGContainer;
}(_react2.default.PureComponent);

SVGContainer.propTypes = {
  // SVG
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  style: _propTypes2.default.object.isRequired,

  items: _propTypes2.default.array.isRequired,
  onSelectChange: _propTypes2.default.func.isRequired,
  onItemsChange: _propTypes2.default.func.isRequired,
  isMovable: _propTypes2.default.bool.isRequired,
  isSelectable: _propTypes2.default.bool.isRequired
};
exports.default = SVGContainer;
module.exports = exports['default'];